import { render, staticRenderFns } from "./indexBak.vue?vue&type=template&id=ae8a371c&scoped=true&"
import script from "./indexBak.vue?vue&type=script&lang=js&"
export * from "./indexBak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8a371c",
  null
  
)

export default component.exports